import { gql } from '@apollo/client';
export const getDocumentConvertedToCcs = gql `
  query GetDocumentConvertedToCcs($documentId: ID!) {
    document: fileSystemDocument(id: $documentId) {
      id
      isConvertedToCcs
    }
  }
`;
